export const placeholder = `/assets/images/placeholder.png`;
// export const noData = `/assets/images/no-data.svg`;
export const noData = `NO_DATA_AVAILABLE`;
export const noNetwork = `NO_NETWORK`;
export const genericError = `GENERIC_ERROR`;
export const noProfilePhoto = `/assets/images/profileimagePH.png`;
export const noHeaderImage = `/assets/images/headerThumbnail.png`;
export const noProductImage = `/assets/images/noProduct.png`;
export const sessionExpiredImage = `/assets/images/session_expired.png`;
export const upgradeMembershipImage = `UPGRADE_MEMBERSHIP`;
export const updateAppImage = `UPDATE_APP`;
export const noIconImage = `https://img.travelx.ai/Homie/thumbnail.png`;
